// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "body {\n  margin: 0 0;\n}", "",{"version":3,"sources":["/home/runner/work/tobimap2/tobimap2/src/styles.sass","styles.sass"],"names":[],"mappings":"AAAA;EACI,WAAA;ACCJ","file":"styles.sass","sourcesContent":["body\n    margin: 0 0","body {\n  margin: 0 0;\n}"]}]);
// Exports
module.exports = exports;
